import React from 'react';
import { Highlight } from '@components';

export default function Home() {
  return (
    <div className="container">
      <Highlight />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ecosystems/Home/Home.jsx